export class WrapUpData {
    interactionTypeVal: any;
    interactionMode: any = 'NA';
    interactionModeSubType: any;
    interactionFeedback: string = '';
    comments: any;
    wrapupTopicList: any = [];
    thirdParty: any;
    primaryTopic: any;
    contactName?: string = '';
    unknownCallerType?: string = '';
    previousUknownCallerType?: string = '';
    unknownCustomerName?: string = '';
    unknownCallerWrapupPage:boolean = false;
}